import { Routes } from '@angular/router';
import { UnderConstructionGuard } from './guards/under-construction.guard';
import { NotConstructionGuard } from './guards/not-construction.guard';

export const routes: Routes = [
    {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full',
    },
    {
      path: 'redirect',
      loadComponent: () => import('./modules/general/pages/redirect/redirect.page').then((m) => m.RedirectPage),
    },
    {
      path: 'under-construction',
      loadComponent: () => import('./modules/general/pages/under-construction/under-construction.page').then( m => m.UnderConstructionPage),
      canActivate: [NotConstructionGuard]
    },
    // //* General Pages
    {
        path: '',
        loadComponent: () => import('./layouts/general/general.component').then((m) => m.GeneralLayout),
        loadChildren: () => import('./routes/app.routes'),
        canActivate: [UnderConstructionGuard]
    },
    {
        path: '**',
        redirectTo : '/home',
        pathMatch: 'full',
    },
];
